import React from 'react';
import { LayoutGrid, Activity, Calculator, Target } from 'lucide-react';

const FEATURES = [
  {
    icon: LayoutGrid,
    title: 'Portfolio tracking',
    body: 'Multi-wallet view, live prices, allocation breakdowns, and full transaction history.',
  },
  {
    icon: Activity,
    title: 'Live market data',
    body: 'Top 200 coins, candlestick charts, sparklines, and instant currency conversion (AUD, USD, EUR, GBP).',
  },
  {
    icon: Calculator,
    title: 'Tax estimator',
    body: 'Understand your CGT position with Australian tax brackets and the 50% discount built in.',
  },
  {
    icon: Target,
    title: 'Strategy',
    body: 'Plan entries and exits with split buy/sell tiers, tax-loss harvesting, and cash-out goal tracking.',
  },
];

export function AllInOneSection() {
  return (
    <section
      id="features"
      className="px-6 py-24"
      style={{ borderTop: '0.5px solid rgba(255,255,255,0.06)' }}
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <div
            className="text-[11px] font-semibold tracking-[0.18em] mb-4"
            style={{ color: '#d4b483' }}
          >
            ALL-IN-ONE WORKSPACE
          </div>
          <h2
            className="font-semibold"
            style={{
              color: '#f4f1ea',
              fontSize: 'clamp(26px, 4vw, 36px)',
              letterSpacing: '-0.02em',
              lineHeight: 1.15,
            }}
          >
            Everything you need, in one place.
          </h2>
          <p
            className="mt-4 text-[15px] leading-relaxed"
            style={{ color: 'rgba(244,241,234,0.6)' }}
          >
            Your entire crypto and stock workflow in one place. Track holdings, log
            transactions, analyse, and plan your strategy, all without switching between apps.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {FEATURES.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="rounded-[10px]"
              style={{
                backgroundColor: 'rgba(255,255,255,0.03)',
                border: '0.5px solid rgba(255,255,255,0.06)',
                padding: '24px',
              }}
            >
              <div
                className="flex items-center justify-center rounded-md"
                style={{
                  width: 36,
                  height: 36,
                  backgroundColor: 'rgba(212,180,131,0.1)',
                }}
              >
                <Icon className="w-4 h-4" style={{ color: '#d4b483' }} />
              </div>
              <h3
                className="mt-4 text-[15px] font-semibold"
                style={{ color: '#f4f1ea' }}
              >
                {title}
              </h3>
              <p
                className="mt-2 text-[13px] leading-relaxed"
                style={{ color: 'rgba(244,241,234,0.55)' }}
              >
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
